import Subtitle, { type SubtitleProps } from "../Subtitle/Subtitle";
import Title, { type TitleProps } from "../Title/Title";
import { cn } from "@/utils/cnHelper";
import * as React from "react";

export type TitleSectionProps = {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  headingElement?: TitleProps["as"];
  className?: string;
  subtitleVariant?: SubtitleProps["variant"];
  align?: "left" | "center";
};

export default function TitleSection({
  title,
  description,
  headingElement = "h2",
  className,
  subtitleVariant = "default",
  align = "center",
}: TitleSectionProps) {
  return (
    <div className={cn("tw-mb-2 tw-pt-4 sm:tw-mb-4 sm:tw-pt-8", align === "left" ? "tw-text-left" : "tw-text-center", className)}>
      <Title as={headingElement} className={cn(align === "center" ? "tw-mx-auto tw-max-w-2xl" : "tw-max-w-full")}>
        {title}
      </Title>
      {description && (
        <Subtitle
          className={cn(
            "tw-mt-8",
            align === "center" ? "tw-mx-auto tw-max-w-4xl" : "tw-max-w-2xl",
            subtitleVariant === "cta" && "!tw-max-w-2xl tw-text-balance"
          )}
          variant={subtitleVariant}
        >
          {description}
        </Subtitle>
      )}
    </div>
  );
}
